const MainPageContainer = ({
  children,
  className,
}: {
  children: any;
  className?: string;
}) => {
  return (
    <div
      id="MainPageContainer"
      className={`flex flex-col gap-3 m-3 ${className}`}
    >
      {children}
    </div>
  );
};

export default MainPageContainer;
